export default {
  TOPIC_CONTENT_TAG: "TopicContentTag",
  ACTIVITY_TYPE_CONTENT_TAG: "ActivityTypeContentTag",
};
